/**
 * 서비스 이용약관 페이지
 *
 * 공통 LegalPageLayout을 사용하여 이용약관을 표시합니다.
 */

import { LegalPageLayout } from './legal';
import { termsContent } from './legal/termsContent';
import { useLanguage } from '@/contexts/AppContext';

interface TermsOfServicePageProps {
  onBack: () => void;
}

export function TermsOfServicePage({ onBack }: TermsOfServicePageProps) {
  const { locale } = useLanguage();
  // #522: 법률 문서는 ko/es/en 만 법무 검토 완료 — 미보유 locale 은 es(멕시코 법적 기준) fallback
  const content = termsContent[locale] ?? termsContent.es;

  return (
    <LegalPageLayout
      title={content.title}
      lastUpdated={content.lastUpdated}
      sections={content.sections}
      onBack={onBack}
    />
  );
}
